import React, { useState, useEffect } from 'react';
import { withNavbar } from './Navbar';
import { withRouterProps } from '../../common/withRouterProps';
import { makeStyles } from "@mui/styles";
import Typography from '@mui/material/Typography';
import { Grid, Tab, Tabs } from '@mui/material';
import { verticalTabStyles } from './sharedStyles';

import CertMgmt from './resources/certmgmt';
import Documents from './admin/catalog/Documents';
import Limits from './resources/Limits';
import Links from './admin/catalog/Links';

const useStyles = makeStyles(() => ({
    pageWrapper: {
        fontSize: '0.8rem',
        height: "100%",
    },
    resourcesTabWrapper: {
        background: '#fff',
        height: "100%"
    },
    headerTitle: {
        fontSize: '1.2rem',
        fontWeight: 800,
        color: '#1e3a5f',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        padding: '0px 0 10px 16px',
        margin: 0,
        borderBottom: '2px solid #267db7',
        marginBottom: '30px',
        display: 'flex',
        alignItems: 'baseline',
        gap: '12px',
        background: 'linear-gradient(90deg, #1e3a5f, #267db7)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    headerSeparator: {
        WebkitTextFillColor: '#1e3a5f',
        fontWeight: 400,
        opacity: 0.5,
    },
    headerSubTitle: {
        fontWeight: 600,
        fontSize: '1rem',
    },
    verticalTabGridItem: {
        maxWidth: '200px',
        background: '#f5f7fa',
        borderRight: '1px solid #e2e8f0',
        borderRadius: '10px 0 0 10px',
        padding: '10px 0',
    },
    verticalTabGridContent: {
        maxWidth: 'calc( 100% - 180px)',
        overflow: 'hidden',
        background: '#fff',
        padding: '15px',
        '& .scopeHeader': {
            display: 'none',
        },
        '& > div > .header, & > div > div > .header': {
            display: 'none',
        },
    },
    ...verticalTabStyles,
}));

const TabHistoryPaths = ["certmgmt", "documents", "limits", "links"];
const TabLabels = ["Cert Mgmt", "Documents", "Limits", "Links"];

function Resources(props) {
    const classes = useStyles();
    const [verticalTab, setVerticalTab] = useState(0);
    const { routerProps } = props;
    const { history, match } = routerProps;

    useEffect(() => {
        if (match?.params?.page) {
            const idx = TabHistoryPaths.indexOf(match.params.page);
            if (idx >= 0) setVerticalTab(idx);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match]);

    return (
        <div className={classes.pageWrapper}>
            <Grid container className={classes.resourcesTabWrapper}>
                <Grid item xs className={classes.verticalTabGridItem}>
                    <div className={classes.verticalTabWrapper}>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={verticalTab}
                            onChange={(_event, newValue) => {
                                setVerticalTab(newValue);
                                const path = TabHistoryPaths[newValue];
                                history.push(`/resources/${path}`);
                            }}
                            aria-label="Vertical tabs"
                        >
                            <Tab label="Cert Mgmt" />
                            <Tab label="Documents" />
                            <Tab label="Limits" />
                            <Tab label="Links" />
                        </Tabs>
                    </div>
                </Grid>
                <Grid item xs className={classes.verticalTabGridContent}>
                    <Typography variant="h6" className={classes.headerTitle}>
                        Resources
                        <span className={classes.headerSeparator}>|</span>
                        <span className={classes.headerSubTitle}>{TabLabels[verticalTab]}</span>
                    </Typography>
                    {verticalTab === 0 && <CertMgmt />}
                    {verticalTab === 1 && <Documents />}
                    {verticalTab === 2 && <Limits />}
                    {verticalTab === 3 && <Links />}
                </Grid>
            </Grid>
        </div>
    );
}

export default withNavbar(withRouterProps(Resources), 3);
